import { useScroll } from 'framer-motion';
import { useRef } from 'react';
import '../App.css';
import AboutUs from '../components/AboutUs';
import Home from '../components/Home';
import Nav from '../components/Nav';
import OurWork from '../components/OurWork';
import ReachOut from '../components/Reachout';
import SiteMap from '../components/SiteMap';

export default function HomeWrapper() {

    const wrapper = useRef(null)

    const { scrollY, scrollYProgress } = useScroll({
        container: wrapper,
    })

    if(!scrollY || !scrollYProgress) {
        return <p>...</p>
    }

    return (
        <div id="app" ref={wrapper}>
            <Nav scrollY={scrollY} scrollYProgress={scrollYProgress} />
            <Home scrollY={scrollY} scrollYProgress={scrollYProgress} />
            <AboutUs scrollY={scrollY} scrollYProgress={scrollYProgress} />
            <OurWork scrollY={scrollY} scrollYProgress={scrollYProgress} />
            <ReachOut scrollY={scrollY} scrollYProgress={scrollYProgress} />
            <SiteMap />
        </div>
    );
}
 
